import Base from 'app/models/base';

import { appUrl } from 'utils/wrappers';

export default Base.extend({
  urlRoot: appUrl('password_resets'),
  rootKey: 'password_reset',
});



// WEBPACK FOOTER //
// ./app/models/password_reset.js